import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { FiltroMovimentacaoEstoque } from "app/types/produto/FiltroMovimentacaoEstoque";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { useMemo, useState } from "react";
import { InputData } from "../inputs/InputData";

const estiloMovimentacaoEstoque = require("./movimentacao-estoque.module.scss").default;
const estiloFormulario = require("./../../estilos/formulario.module.scss").default;
const estiloInputs = require("./../../estilos/inputs.module.scss").default;
const estiloBotoes = require("./../../estilos/botoes.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default


export type ListaTipo = {
  AceitaLancamento: boolean;
  Codigo: string;
  Descricao: string;
  HierarquiaMascara: string;
  HierarquiaNumero: string;
  Nome: string;
  Oid: number;
  UserMessage: string;
};

export type Filial = {
  Celular?: string
  Codigo: string
  Descricao: string
  Endereco: any
  EnderecoComercial: any
  Identificador: string
  InscricaoEstadual: string
  Nome: string
  Oid: number
  RazaoSocial?: any
  Telefone: string
  Transforming: boolean
  UserMessage?: string
};

export type MovimentacaoEstoque = {
  Filial: string;
  DataNF: string;
  NF: string;
  ClieFor: string;
  Qtde: number;
  ValUnit: number;
  TPO: string;
  CodTpo: string;
  FilTransf: string;
  UserMessage: string;
};

export type MovimentacaoEstoqueProps = {
  movimentacaoEstoque: MovimentacaoEstoque[];
  filtroMovimentacaoEstoque: FiltroMovimentacaoEstoque;
  onPesquisar: (filtroMovimentacaoEstoque: FiltroMovimentacaoEstoque) => void;
  codigo: string;
  descricao: string;
  filiais: Filial[];
  listaTpo: ListaTipo[];
  onListarTposPorAtributo: (atributo: string) => void;
};

export const MovimentacaoEstoques = React.memo((props: MovimentacaoEstoqueProps) => {

  const formik = useFormik({
    initialValues: { ...props.filtroMovimentacaoEstoque },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });
  const [inputValue, setInputValue] = useState<string>("");

  const detalheProdutoSelecionado = <div className={estiloFormulario.gridDuasColunas}>
    <div>Produto</div>
    <div>{props.codigo}</div>
    <div>Descrição</div>
    <div>{props.descricao}</div>
  </div>

  const filtros = useMemo(() => {
    const dataInicial = <div className={estiloMovimentacaoEstoque.formMovimentacao}>
      <label>
        Data Inicial{" "}
        <p className={estiloInputs.obrigatorio}>*</p>
      </label>
       <InputData
        id="MovimentacaoEstoque_dataInicial"
        key="MovimentacaoEstoque_dataInicial"
        // `cond && classe` entrega `false` quando cond e falsa, e o React avisa "Received `false` for
        // a non-boolean attribute `className`". Ternario com undefined OMITE o atributo.
        className={formik.values.filtroDataFim != "" && formik.values.filtroDataInicio == "" ? estiloInputs.inputComErro : undefined}
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.filtroDataInicio)}
        onChange={(e) => formik.setFieldValue("filtroDataInicio", e)}
        selecionaValorOnFocus
      />
    </div> 

    const dataFinal = <div className={estiloMovimentacaoEstoque.formMovimentacao}>
      <label>
        Data Final<p className={estiloInputs.obrigatorio}>*</p>
      </label>
      <InputData
        id="MovimentacaoEstoque_dataFinal"
        key="MovimentacaoEstoque_dataFinal"
        className={formik.values.filtroDataInicio != "" && formik.values.filtroDataFim == "" ? estiloInputs.inputComErro : undefined}
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.filtroDataFim)}
        onChange={(e) => formik.setFieldValue("filtroDataFim", e)}
        selecionaValorOnFocus
      />
    </div>

    const filial = <div className={estiloMovimentacaoEstoque.formMovimentacao}>
      <label>Filial</label>
      <select
        className="_w[200px]"
        name="filial"
        id="MovimentacaoEstoque_filial"
        // ?? "" obrigatório: MovimentacaoEstoqueContainer inicializa o filtro com `filial: null`, e
        // isso vai direto para initialValues do formik. Um select com value nulo faz o React avisar
        // "`value` prop on `select` should not be null" e tratar o campo como não-controlado. String
        // vazia é o que seleciona a option "Selecione" mantendo o campo controlado.
        value={formik.values?.filial ?? ""}
        onChange={formik.handleChange}
      >
        <option value="">Selecione</option>
        {props.filiais?.map((filial) => (
          <option key={filial.Codigo} value={filial.Codigo}>
            {filial.Codigo + "-" + filial.Nome}
          </option>
        ))}
      </select>
    </div>

    const filtroTipoOperacao = <div className="_flex _items-baseline">
      <label 
        htmlFor="MovimentacaoTpo_pesquisarTpo" 
        className="_cursor-pointer _font-normal _px-1 _pr-[10px] _w-[160px] _text-right"
        title="Filtrar TpO"
      >Filtrar Tipo de Operação</label>
      <input
        className="_w-4 _h-4 _mt-2 _p-2"
        type="checkbox"
        name="pesquisarTpo"
        title="Escolha os TpO"
        id="MovimentacaoTpo_pesquisarTpo"
        checked={formik.values?.pesquisarTpo ?? false}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
    </div>

    const adicionarTipoOperacao = formik.values.pesquisarTpo && (
      <div className={estiloMovimentacaoEstoque.gridAutocomplete}>
        <label>
          Adicionar Tipo de Operação (TpO)
        </label>

        <div className={`${estiloMovimentacaoEstoque.autocomplete} ${formik.values.listaTpo?.length == 0 && "_h-[30px]"}`}>
          <Autocomplete
            noOptionsText={"Digite 3 ou mais caracteres"}
            multiple
            id="MovimentacaoEstoque_listaTpo"
            options={props.listaTpo ?? []}
            value={props.listaTpo?.filter((profissional) => formik.values.listaTpo?.indexOf(profissional.HierarquiaNumero) != -1)}
            getOptionLabel={(profissional) => profissional.Descricao}
            inputValue={inputValue}
            onInputChange={(event, value, reason) => {
              if ((event && event.type === 'blur')) {
                setInputValue('');
              } else if (reason !== 'reset') {
                setInputValue
                value.length >= 3 && value.includes("%") ? setInputValue(value.replace(/%/g, "")) : setInputValue(value)
                props.onListarTposPorAtributo(value)
              }
            }}
            // MUI v9: `placeholder`/`title` deixaram de ser aceitos no Autocomplete (no v4 eram
            // repassados ao elemento raiz por spread). Movidos para o TextField do renderInput,
            // que é onde o usuário efetivamente vê o placeholder e o tooltip.
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Digite 3 ou mais caracteres"
                title="Escolha os TpO"
              />
            )}
            onChange={(_e, codigoProfissional) => {
              formik.setFieldValue("listaTpo", codigoProfissional?.map((profissional) => (profissional as ListaTipo).HierarquiaNumero));
            }}
            disablePortal={true}
          />
        </div>
      </div>
    )

    return <>
      <React.Fragment key="dataInicial">{dataInicial}</React.Fragment>
      <React.Fragment key="dataFinal">{dataFinal}</React.Fragment>
      <React.Fragment key="filial">{filial}</React.Fragment>
      <React.Fragment key="filtroTipoOperacao">{filtroTipoOperacao}</React.Fragment>
      <React.Fragment key="adicionarTipoOperacao">{adicionarTipoOperacao}</React.Fragment>
    </>
  }, [formik.values, props.filiais, props.listaTpo, inputValue, props.onListarTposPorAtributo]);

  const btnPesquisar = <button className={clsx("no-global-button _mt-4", estiloBotoes.botaoPrimario)} onClick={() => { props.onPesquisar(formik.values) }}>
    Pesquisar
  </button>

  const tabela = useMemo(() => {

    const tableHead = <div className="_table-header-group">
      <div className="_table-row">
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "left" }}
        >
          Filial
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "left" }}
        >
          Data
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "left" }}
        >
          Nota Fiscal
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "left" }}
        >
          Cliente / Fornecedor
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "right" }}
        >
          Quantidade
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "right" }}
        >
          Vr. Unitário
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          style={{ textAlign: "left" }}
        >
          TPO
        </div>
      </div>
    </div>

    const tableBody = <div className="_table-row-group">
      {props?.movimentacaoEstoque?.map((value, index) => (
        <div key={index}
          className="_table-row _cursor-pointer hover:_bg-white"
        >
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
            style={{ textAlign: "left" }}
          >
            {value.Filial}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
            style={{ textAlign: "left" }}
          >
            {globalMU.formatDate(value.DataNF)}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
            style={{ textAlign: "left" }}
          >
            {value.NF}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {value.ClieFor}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
            style={{ textAlign: "right" }}
          >
            {globalMU.formatarValorNumerico(value.Qtde, 3)}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
            style={{ textAlign: "right" }}
          >
            {Number.isNaN(Number(value.ValUnit)) ? "" : globalMU.formatarValorNumerico(value.ValUnit, 3)}
          </div>
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {value.TPO}
          </div>
        </div>
      ))}
    </div>

    return <div className="_table _w-full _border-collapse _mt-4">
      {tableHead}
      {tableBody}
    </div>
  }, [props.movimentacaoEstoque]);


  return (
    <>
      <div>
        {detalheProdutoSelecionado}
        <br />
        {filtros}
        {btnPesquisar}
        <div className={estiloTabela.containerRolavel}>
          {tabela}
        </div>
        {<section style={{ marginBottom: "100px" }} />}
      </div>
    </>
  );
});
